var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheckedActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    transform: "translate(-1121 -672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    transform: "translate(1121 672)",
    fill: "#1de993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    d: "M4.639,14.2a1.45,1.45,0,0,1-1.027-.426L.439,10.6,1.65,9.392l2.989,2.989L12.42,4.6l1.211,1.21L5.666,13.774a1.45,1.45,0,0,1-1.027.426Z",
    transform: "translate(1125.965 674.601)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckedActive);
export default __webpack_public_path__ + "static/media/circle-checked-active.ada5c9694dc1b8e55c229a29b22dba5c.svg";
export { ForwardRef as ReactComponent };